import React, {useEffect, useState} from "react";
import {css} from "@panda/css";
import classNames from "classnames";

import {CenterBox} from "@pg-design/grid-module";
import {Image} from "@pg-design/image-module";
import {Loader} from "@pg-design/loader-module";
import {Text} from "@pg-design/text-module";

import {ApplicationSource, ApplicationSourceSection} from "../../../application/utils/ApplicationSource";
import {AddToFavouritesButton} from "../../../my_offers/components/AddToFavouritesButton";
import {IOfferDetail} from "../../../offer/types/IOfferDetail";
import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {setPriceConversationConsultant} from "../../state/main_lead_slice";
import {ILeadModalPriceConversationConsultant} from "../../types/ILeadModalPriceConversationConsultant";
import {getRandomConsultant} from "../../utils/get_random_consultant";
import {LeadSidebarForm} from "./LeadSidebarForm";

interface IProps {
    vendor: {
        name: string;
        id: number;
    };
    offerId: IOfferDetail["id"];
    propertyId?: IPropertyDetail["id"];
    source: ApplicationSource;
    sourceSection: ApplicationSourceSection;
    sidebarBg?: "light" | "dark";
    blockScrolling?: boolean;
}

export const LeadSidebarVariantA = (props: IProps) => {
    const leadConsultant = useAppSelector((state) => state.mainLead.consultant);
    const [consultant, setConsultant] = useState<ILeadModalPriceConversationConsultant | null>(null);
    const dispatch = useAppDispatch();

    useEffect(() => {
        setConsultant(getRandomConsultant());
    }, []);

    useEffect(() => {
        if (leadConsultant && !consultant) {
            setConsultant(leadConsultant);
        }
        if (!leadConsultant && consultant) {
            dispatch(setPriceConversationConsultant(consultant));
        }
    }, [leadConsultant, consultant]);

    return (
        <div>
            <div className={classNames(boxWrapper, !props.blockScrolling && scrollableStyle)}>
                {consultant ? (
                    <div className={consultantInfoWrapper}>
                        <Image width="72px" height="72px" alt="zdjęcie konsultanta" src={consultant.image.s72} className={consultantInfoImage} />
                        <div>
                            <Text variant="headline_6" as="p" strong>
                                {props.vendor.name}
                            </Text>
                            <Text variant="headline_6" as="p">
                                {consultant.fullName}
                            </Text>
                            <Text variant="body_copy_2">Konsultant dewelopera</Text>
                        </div>
                    </div>
                ) : (
                    <CenterBox className={css({mb: 3})}>
                        <Loader />
                    </CenterBox>
                )}

                <LeadSidebarForm
                    vendorId={props.vendor.id}
                    offerId={props.offerId}
                    propertyId={props.propertyId}
                    source={props.source}
                    sourceSection={props.sourceSection}
                />
            </div>
            {props.propertyId && props.offerId && (
                <div className={addToFavouritesButtonWrapStyle}>
                    <AddToFavouritesButton
                        className={addToFavouritesButtonStyle}
                        propertyId={props.propertyId}
                        offerId={props.offerId}
                        theme={props.sidebarBg ? props.sidebarBg : "light"}
                    />
                </div>
            )}
        </div>
    );
};

const boxWrapper = css({
    width: "100%",
    backgroundColor: "white",
    height: "fit-content",
    borderRadius: 2,
    boxShadow: "0 16px 40px rgba(174,177,180,0.2)",
    p: 1.5
});

const scrollableStyle = css({
    maxHeight: "calc(100vh - (var(--globals-baseUnit) * 25))",
    overflowY: "auto"
});

const consultantInfoImage = css({
    borderRadius: "50%",
    minHeight: "72px",
    minWidth: "72px"
});

const consultantInfoWrapper = css({
    display: "flex",
    flexDirection: "row",
    gap: 2,
    justifyContent: "start",
    alignItems: "center",
    mb: 3
});

const addToFavouritesButtonWrapStyle = css({
    display: "flex",
    justifyContent: "center",
    marginTop: 2
});

const addToFavouritesButtonStyle = css({
    marginTop: 2
});
import React, {useEffect, useState} from "react";
import {css} from "@panda/css";
import classNames from "classnames";

import {CenterBox} from "@pg-design/grid-module";
import {Image} from "@pg-design/image-module";
import {Loader} from "@pg-design/loader-module";
import {Text} from "@pg-design/text-module";

import {ApplicationSource, ApplicationSourceSection} from "../../../application/utils/ApplicationSource";
import {AddToFavouritesButton} from "../../../my_offers/components/AddToFavouritesButton";
import {IOfferDetail} from "../../../offer/types/IOfferDetail";
import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {setPriceConversationConsultant} from "../../state/main_lead_slice";
import {ILeadModalPriceConversationConsultant} from "../../types/ILeadModalPriceConversationConsultant";
import {getRandomConsultant} from "../../utils/get_random_consultant";
import {LeadSidebarForm} from "./LeadSidebarForm";

interface IProps {
    vendor: {
        name: string;
        id: number;
    };
    offerId: IOfferDetail["id"];
    propertyId?: IPropertyDetail["id"];
    source: ApplicationSource;
    sourceSection: ApplicationSourceSection;
    sidebarBg?: "light" | "dark";
    blockScrolling?: boolean;
}

export const LeadSidebarVariantA = (props: IProps) => {
    const leadConsultant = useAppSelector((state) => state.mainLead.consultant);
    const [consultant, setConsultant] = useState<ILeadModalPriceConversationConsultant | null>(null);
    const dispatch = useAppDispatch();

    useEffect(() => {
        setConsultant(getRandomConsultant());
    }, []);

    useEffect(() => {
        if (leadConsultant && !consultant) {
            setConsultant(leadConsultant);
        }
        if (!leadConsultant && consultant) {
            dispatch(setPriceConversationConsultant(consultant));
        }
    }, [leadConsultant, consultant]);

    return (
        <div>
            <div className={classNames(boxWrapper, !props.blockScrolling && scrollableStyle)}>
                {consultant ? (
                    <div className={consultantInfoWrapper}>
                        <Image width="72px" height="72px" alt="zdjęcie konsultanta" src={consultant.image.s72} className={consultantInfoImage} />
                        <div>
                            <Text variant="headline_6" as="p" strong>
                                {props.vendor.name}
                            </Text>
                            <Text variant="headline_6" as="p">
                                {consultant.fullName}
                            </Text>
                            <Text variant="body_copy_2">Konsultant dewelopera</Text>
                        </div>
                    </div>
                ) : (
                    <CenterBox className={css({mb: 3})}>
                        <Loader />
                    </CenterBox>
                )}

                <LeadSidebarForm
                    vendorId={props.vendor.id}
                    offerId={props.offerId}
                    propertyId={props.propertyId}
                    source={props.source}
                    sourceSection={props.sourceSection}
                />
            </div>
            {props.propertyId && props.offerId && (
                <div className={addToFavouritesButtonWrapStyle}>
                    <AddToFavouritesButton
                        className={addToFavouritesButtonStyle}
                        propertyId={props.propertyId}
                        offerId={props.offerId}
                        theme={props.sidebarBg ? props.sidebarBg : "light"}
                    />
                </div>
            )}
        </div>
    );
};

const boxWrapper = css({
    width: "100%",
    backgroundColor: "white",
    height: "fit-content",
    borderRadius: 2,
    boxShadow: "0 16px 40px rgba(174,177,180,0.2)",
    p: 1.5
});

const scrollableStyle = css({
    maxHeight: "calc(100vh - (var(--globals-baseUnit) * 25))",
    overflowY: "auto"
});

const consultantInfoImage = css({
    borderRadius: "50%",
    minHeight: "72px",
    minWidth: "72px"
});

const consultantInfoWrapper = css({
    display: "flex",
    flexDirection: "row",
    gap: 2,
    justifyContent: "start",
    alignItems: "center",
    mb: 3
});

const addToFavouritesButtonWrapStyle = css({
    display: "flex",
    justifyContent: "center",
    marginTop: 2
});

const addToFavouritesButtonStyle = css({
    marginTop: 2
});
